const taskMenu: any = {
  id: "todo",
  title: "Task",
  translate: "MENU.TODO",
  type: "item",
  icon: "check-square",
  url: "dashboard/my-todo",
  order: 4,
};

export default taskMenu;
